module.exports = __webpack_public_path__ + "static/media/1-overview-of-knee-arthroscopy-01@3x.454fc728.jpg";